import request from '@/utils/request'

export function pageDeliveryTask (params) {
  return request({ url: '/erp/delivery/task/page', method: 'get', params })
}

export function getDeliveryTask (id) {
  return request({ url: '/erp/delivery/task/detail', method: 'get', params: { id } })
}

export function dispatchDeliveryTask (data) {
  return request({ url: '/erp/delivery/task/dispatch', method: 'post', data })
}

export function pageDeliveryRoute (params) {
  return request({ url: '/erp/delivery/route/page', method: 'get', params })
}

export function getDeliveryRoute (id) {
  return request({ url: '/erp/delivery/route/detail', method: 'get', params: { id } })
}

export function exportDeliveryRoute (ids) {
  return request({
    url: '/erp/delivery/route/export',
    method: 'post',
    data: { ids },
    responseType: 'blob'
  })
}

export function confirmDeliveryRoute (id) {
  return request({ url: '/erp/delivery/route/confirm', method: 'post', params: { id } })
}

export function departDeliveryRoute (id) {
  return request({ url: '/erp/delivery/route/depart', method: 'post', params: { id } })
}

export function pageDeliverySign (params) {
  return request({ url: '/erp/delivery/sign/page', method: 'get', params })
}

export function getDeliverySign (id) {
  return request({ url: '/erp/delivery/sign/detail', method: 'get', params: { id } })
}

export function confirmDeliverySign (data) {
  return request({ url: '/erp/delivery/sign/confirm', method: 'post', data })
}
